import {
  CREATE_LOBBY,
  FETCH_LOBBIES,
  FETCH_LOBBY,
  LIST_LOBBIES,
  SHOW_LOBBY,
  UPDATE_LOBBY
} from "./types";

const init = {
  isLoading: true,
  list: [],
  page: 1,
  totals: 0,
  size: 25,
  active: {
    lobby: {},
    isLoading: true
  }
};

export default (state = init, {type, payload}) => {
  switch (type) {
    case FETCH_LOBBIES:
      return {
        ...state,
        isLoading: true
      };
    case LIST_LOBBIES:
      return {
        ...state,
        ...payload,
        list: payload.list || [],
        isLoading: false
      };
    case FETCH_LOBBY:
      return {
        ...state,
        active: {
          lobby: {},
          isLoading: true
        }
      };
    case SHOW_LOBBY:
      return {
        ...state,
        active: {
          lobby: payload || {},
          isLoading: false
        }
      };
    case CREATE_LOBBY:
    case UPDATE_LOBBY:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
};
